import error from '~/store/plugin/error'

export default defineNuxtPlugin(async () => {
  usePinia().use(error)
})
